import { render, staticRenderFns } from "./UsersPrivilegeMedicalAlerts.vue?vue&type=template&id=568df5a6&scoped=true&"
import script from "./UsersPrivilegeMedicalAlerts.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeMedicalAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568df5a6",
  null
  
)

export default component.exports